// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3_Ikm","vLegacy":"SelectSecondary_vLegacy__38a5l","error":"SelectSecondary_error__2-tAB","disabled":"SelectSecondary_disabled__3C7gp"};